import React from 'react';
import './BasicUserPanel.css';
import SearchCounterBadge from './SearchCounterBadge';
import appLogo from '../assets/lastnik.png';

const BasicUserPanel = ({ address, setAddress, isConnected, onSearch, searchCounter, onPay, userError }) => {
  const canSearch = Boolean(address?.trim()) && !isConnected;
  const supportEmail = 'info@sirisense.com';

  const handleSubmit = (event) => {
    event.preventDefault();
    if (canSearch) {
      onSearch();
    }
  };

  return (
    <div className="basic-user-panel">
      {searchCounter && !searchCounter.isLoading && (
        <div className="counter-container">
          <SearchCounterBadge
            remainingSearches={searchCounter.remainingSearches}
            requiresPayment={searchCounter.requiresPayment}
            onPay={onPay}
          />
        </div>
      )}

      <div className="magnifier">
        <div className="magnifier-lens">
          <div className="lens-reflection" aria-hidden="true"></div>
          {isConnected && <div className="lens-progress" aria-hidden="true"></div>}
          <img src={appLogo} alt="Kdo je lastnik" className="lens-logo" />

          <div className="lens-content">
            {/* <p className="basic-user-hint">
              Vnesite naslov nepremičnine
            </p> */}

            <form className="basic-user-form" onSubmit={handleSubmit}>
              <div className="basic-user-error-slot">
                {userError && <span>{userError}</span>}
              </div>
              <input
                type="text"
                className="basic-user-input"
                placeholder="Naslov (npr. Dunajska cesta 1, Ljubljana)"
                value={address}
                onChange={(event) => setAddress(event.target.value)}
                disabled={isConnected}
              />

              <button className="basic-user-button" type="submit" disabled={!canSearch}>
                {isConnected ? 'Iskanje...' : 'Išči'}
              </button>
            </form>
          </div>
        </div>
      </div>

      <div className="basic-user-contact">
        <a href={`mailto:${supportEmail}`}>Podpora in vprašanja</a>
      </div>
    </div>
  );
};

export default BasicUserPanel;
